// import React, { Component } from 'react';
// import ReactApexChart from 'react-apexcharts';

// class lineareachart extends Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             options: {
//                 chart: {
//                     height: 350,
//                     type: 'area',
//                 },
//                 dataLabels: {
//                     enabled: false
//                 },
//                 stroke: {
//                     curve: 'smooth',
//                     width: 3,
//                 },
                
//                 colors: ['#556ee6'],
//                 xaxis: {
//                     type: 'datetime',
//                     categories: ["2018-09-19T00:00:00", "2018-09-19T01:30:00", "2018-09-19T02:30:00", "2018-09-19T03:30:00", "2018-09-19T04:30:00", "2018-09-19T05:30:00", "2018-09-19T06:30:00"],                
//                 },
//                 grid: {
//                     borderColor: '#f1f1f1',
//                 },
//                 tooltip: {
//                     x: {
//                         format: 'dd/MM/yy HH:mm'
//                     },
//                 }
//             },
//             series: [{
//                 name: 'series1',
//                 data: [34, 40, 28, 52, 42, 109, 100]
//             }]
//         }
//     }
//     render() {
//         return (
//             <React.Fragment>
//                 <ReactApexChart options={this.state.options} series={this.state.series} type="area" height="300px" />
//             </React.Fragment>
//         );
//     }
// }

// export default lineareachart;

import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const LineAreaChart = ({ chartData }) => {
  const [series, setSeries] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    if (chartData.length > 0) {
      const months = chartData.map(item => item.month + "-01");
      const totals = chartData.map(item => item.total_amount);

      setCategories(months);
      setSeries([{ name: "Total Amount", data: totals }]);
    }
  }, [chartData]);

  const options = {
    chart: {
      height: 350,
      type: 'area',
    },
    dataLabels: { enabled: false },
    stroke: { curve: 'smooth', width: 3 },
    colors: ['#556ee6'],
    xaxis: {
      type: 'datetime',
      categories: categories,
      labels: {
        format: 'MMM',
      }
    },
    tooltip: {
      x: {
        format: 'MMMM yyyy',
      },
      y: {
        formatter: (val) => `LYD ${val?.toLocaleString()}`
      }
    },
    grid: {
      borderColor: '#f1f1f1',
    },
  };

  return (
    <ReactApexChart options={options} series={series} type="area" height={300} />
  );
};

export default LineAreaChart;
